/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteTopGasSpenderRequest = {
    period?: KiteTopGasSpenderRequest.period;
    type?: KiteTopGasSpenderRequest.type;
    sort?: KiteTopGasSpenderRequest.sort;
    direction?: KiteTopGasSpenderRequest.direction;
};

export namespace KiteTopGasSpenderRequest {

    export enum period {
        H24 = 'H24',
        D7 = 'D7',
    }

    export enum type {
        EOA = 'EOA',
        CA = 'CA',
        ALL = 'ALL',
    }

    export enum sort {
        TOTAL_GAS_USED = 'TOTAL_GAS_USED',
        TRX_COUNT = 'TRX_COUNT',
    }

    export enum direction {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

